import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import type { AppMenu } from '@modules/sidebar/utils';
import { AppModule } from '@modules/core/plugins/AppModule';
import { ADMIN_GENERAL_SETTINGS_ROUTE_NAME } from '@modules/general-settings/constants';
import {
  ADMIN_GENERAL_SETTINGS_BOOKKEEPING_LIST_ROUTE_NAME,
  ADMIN_GENERAL_SETTINGS_BOOKKEEPING_PERMISSIONS,
  ADMIN_GENERAL_SETTINGS_BOOKKEEPING_ROUTE_NAME,
  ADMIN_GENERAL_SETTINGS_BOOKKEEPING_UPDATE_ROUTE_NAME,
  TRANSLATION_GROUP_GENERAL_SETTINGS_BOOKKEEPING,
} from '@modules/general-settings/submodules/bookkeeping/constants';
import { useI18n } from '@modules/i18n/composables';

import { getTranslationKeys } from './translations';

export class AdminGeneralSettingsBookkeepingModule extends AppModule {
  addRoutes(router: AppVueRouter): void {
    router.addChildRoute(ADMIN_GENERAL_SETTINGS_ROUTE_NAME, {
      name: ADMIN_GENERAL_SETTINGS_BOOKKEEPING_ROUTE_NAME,
      path: 'bookkeeping',
      permission: ADMIN_GENERAL_SETTINGS_BOOKKEEPING_PERMISSIONS.HISTORYOFLIMITCHANGES_CREATE,
      component: () => import('@modules/core/components/SimpleChildRoutePage/SimpleChildRoutePage.vue'),
      keepAliveInclude: 'AdminGeneralSettingsBookkeepingPage',
    });

    router.addChildRoute(ADMIN_GENERAL_SETTINGS_BOOKKEEPING_ROUTE_NAME, {
      name: ADMIN_GENERAL_SETTINGS_BOOKKEEPING_LIST_ROUTE_NAME,
      path: '',
      component: () => import('@modules/general-settings/submodules/bookkeeping/pages/AdminGeneralSettingsBookkeepingPage/AdminGeneralSettingsBookkeepingPage.vue'),
    });

    router.addChildRoute(ADMIN_GENERAL_SETTINGS_BOOKKEEPING_ROUTE_NAME, {
      name: ADMIN_GENERAL_SETTINGS_BOOKKEEPING_UPDATE_ROUTE_NAME,
      path: ':merchantId/history/:itemId',
      permission: ADMIN_GENERAL_SETTINGS_BOOKKEEPING_PERMISSIONS.HISTORYOFLIMITCHANGES_EDIT,
      meta: {
        hideParentModuleWrapper: true,
      },
      component: () => import('@modules/general-settings/submodules/bookkeeping/pages/AdminGeneralSettingsBookkeepingUpdatePage/AdminGeneralSettingsBookkeepingUpdatePage.vue'),
    });
  }

  addMenu(menu: AppMenu): void {
    const { getTPath } = useI18n();

    menu.addChildAdminMenuItem(ADMIN_GENERAL_SETTINGS_ROUTE_NAME, {
      caption: getTPath(TRANSLATION_GROUP_GENERAL_SETTINGS_BOOKKEEPING, 'TAB_NAME'),
      to: {
        name: ADMIN_GENERAL_SETTINGS_BOOKKEEPING_LIST_ROUTE_NAME,
      },
      permission: ADMIN_GENERAL_SETTINGS_BOOKKEEPING_PERMISSIONS.HISTORYOFLIMITCHANGES_CREATE,
      id: ADMIN_GENERAL_SETTINGS_BOOKKEEPING_LIST_ROUTE_NAME,
      order: 50,
    });
  }

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUP_GENERAL_SETTINGS_BOOKKEEPING, getTranslationKeys);
  }
}
